// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uTvQO","type":"styles_type__NQ8Mf","choices":"styles_choices__1GSpx"};